"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var session_schema_exports = {};
__export(session_schema_exports, {
  ClientSessionSchema: () => ClientSessionSchema,
  SessionCookieSchema: () => SessionCookieSchema,
  UserSchema: () => UserSchema
});
module.exports = __toCommonJS(session_schema_exports);
var import_typebox = require("@sinclair/typebox");
var import_token = require("./token.schema");
const UserSchema = import_typebox.Type.Object({
  isNewUser: import_typebox.Type.Boolean(),
  userId: import_typebox.Type.String(),
  email: import_typebox.Type.String(),
  validProfile: import_typebox.Type.Boolean()
});
const SessionCookieSchema = import_typebox.Type.Composite([
  import_token.TokenResponseSchema,
  UserSchema
]);
const ClientSessionSchema = import_typebox.Type.Object({
  user: import_typebox.Type.Object({
    email: import_typebox.Type.String(),
    isNewUser: import_typebox.Type.Boolean(),
    id: import_typebox.Type.String()
  }),
  activeSession: import_typebox.Type.Boolean(),
  expires: import_typebox.Type.String(),
  token: import_typebox.Type.Object({
    accessToken: import_typebox.Type.String(),
    expiresAt: import_typebox.Type.Number()
  })
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ClientSessionSchema,
  SessionCookieSchema,
  UserSchema
});
